module.exports = __webpack_public_path__ + "static/img/hero-bg.3e4b5c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-bg.jpg
// module id = nyZu
// module chunks = 0